import React, { createContext, useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { findMatchObj } from 'constants/helper';

const MatchedRouteContext = createContext({});

const MatchedRouteProvider = ({ children }) => {
  const [matchedRouteObj, setMatchedRouteObj] = useState({});
  const location = useLocation();

  useEffect(() => {
    setMatchedRouteObj(findMatchObj(location.pathname) || { pageName: location.pathname, match: {} });
  }, [location.pathname]);

  return (
    <MatchedRouteContext.Provider
      value={{
        pageName: matchedRouteObj?.pageName,
        match: matchedRouteObj?.match,
      }}
    >
      {children}
    </MatchedRouteContext.Provider>
  );
};

const useMatchedRoute = () => useContext(MatchedRouteContext);

export { MatchedRouteProvider, useMatchedRoute };
